import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Arrow from './Arrow';

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__cta">
          <div>
            <h2>{t('join.title')}</h2>
            <p>{t('join.lead')}</p>
          </div>
          <Link to="/join" className="btn btn--primary">
            {t('cta.join')} <Arrow className="btn__arrow" />
          </Link>
        </div>

        <div className="footer__grid">
          <div>
            <span className="footer__wordmark">Napho</span>
            <p className="footer__tagline">{t('footer.tagline')}</p>
            <div className="footer__badges" aria-label={t('footer.apps')}>
              <span className="badge-store">▶ Google Play - soon</span>
              <span className="badge-store"> App Store - soon</span>
            </div>
          </div>

          <div className="footer__links">
            <h4>{t('footer.product')}</h4>
            <Link to="/why">{t('nav.why')}</Link>
            <Link to="/market-pulse">{t('nav.pulse')}</Link>
            <Link to="/ask">{t('nav.ask')}</Link>
            <Link to="/join">{t('nav.join')}</Link>
          </div>

          <div className="footer__links">
            <h4>{t('footer.legal')}</h4>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/disclaimers">Disclaimers</Link>
          </div>

          <div className="footer__links">
            <h4>{t('footer.contact')}</h4>
            <a href="mailto:admin@napho.in">admin@napho.in</a>
            <a href="tel:+917620889905">+91 76208 89905</a>
            <span style={{ fontSize: '0.85rem' }}>India</span>
          </div>
        </div>

        <div className="footer__bottom">
          <span>© {year} Napho. {t('footer.rights')}</span>
          <span>{t('footer.entity')}</span>
        </div>
      </div>
    </footer>
  );
}
